import React, {
  useEffect,
  useCallback,
} from 'react';

import {
  getStatus,
} from 'redux-resource';

import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  uiActions,
} from 'web-actions';
import {
  history,
} from 'web-history';

import {
  Flex,
} from 'web-styled';

import {
  Button,
  Spinner,
} from 'web-components';


import ClientDetailsList from '../ClientDetailsList';

type Props = {
  folderId: number,
  clientInfo: any,
  resourceType: string,
}

const Exercises = ({
  folderId,
  clientInfo,
  resourceType,
}: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      coreActions.requestClientPersonalEntity({
        clientId: clientInfo.id,
        resourceType,
      }),
    );
  }, [clientInfo.id, resourceType]);

  const mapState = useCallback(state => ({
    items: coreSelectors.getClientTemplates(
      clientInfo.id,
      'personalExercises',
    )(state),
    assigningStatus: getStatus(
      state,
      [
        'personalExercises.requests.assignClient.status',
        'personalExercises.requests.unAssignClient.status',
      ],
    ),
    fetchingExercisesStatus: getStatus(
      state,
      [
        'personalExercises.requests.fetchPersonalExercises.status',
      ],
    ),
  }), [clientInfo.id, resourceType]);

  const {
    items,
    assigningStatus,
    fetchingExercisesStatus,
  } = useSelector(mapState, shallowEqual);

  const onRequestDeleteItem = (id) => {
    const onConfirmAction = coreActions.requestUnassignFromClient({
      id,
      clientId: clientInfo.id,
      resourceType,
    });

    dispatch(
      uiActions.confirmModal({
        modal: {
          title: 'Delete item',
          bodyText: 'Are you sure you want to delete selected item?',
        },
        onConfirmAction,
      }),
    );
  };

  return (
    <Flex
      fillSpace
    >
      {fetchingExercisesStatus.pending && (
        <Spinner message="Loading..." />
      )}

      {fetchingExercisesStatus.succeeded && (
        <Flex
          column
          fillSpace
          spacing={10}
        >
          {(!assigningStatus.pending && items) && (
            <ClientDetailsList
              items={items}
              tabName="exercises"
              onRequestDeleteItem={onRequestDeleteItem}
              emptyState={(
                <>
                  <span>
                    <br />
                    No exercises currently assigned
                    <br />
                    to this client
                    <br />
                    <br />
                    To add specific exercise, enter
                    <br />
                    exercise name in search bar
                    <br />
                    above. To see a list of exercises in
                    <br />
                    your library, select &quot;See exercise list&quot;
                    <br />
                    below.
                  </span>
                  <Button
                    ghost
                    appearance="primary"
                    onClick={() => {
                      history.push(`/exercises_folder/${folderId}`);
                    }}
                  >
                    See Exercise List
                  </Button>
                </>
              )}
            />
          )}
          {assigningStatus.pending && (
            <Spinner message="Assigning exercise..." />
          )}
        </Flex>
      )}
    </Flex>
  );
};

export default Exercises;
